<div class="main-container animated fadeInRight ci-history-container">
  <mat-card class="ci-history-card">
    <mat-card-content>
      <div class="ci-history-header">
        <div class="ci-history-title">History of {{ item?.name }}</div>
        <button mat-icon-button type="button" (click)="closeHistory()" matTooltip="done" matTooltipPosition="below">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <div class="ci-history-empty" *ngIf="history.length == 0; else historyTable">
        <small>{{ historyLabel }}</small>
      </div>

      <ng-template #historyTable>
        <div class="ci-history-table-wrap">
          <table class="ci-history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Form Modified</th>
                <th>Old Value</th>
                <th>New Value</th>
                <th>Username</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of history">
                <td>{{ h.created }}</td>
                <td>{{ h.createdTime }}</td>
                <td>{{ h.field }}</td>
                <td>{{ h.oldValue }}</td>
                <td>{{ h.newValue }}</td>
                <td>{{ h.author }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>